module.exports = __webpack_public_path__ + "img/icon_change.07b7d7a0.svg";